import { render, staticRenderFns } from "./DadosdoSubordinado.vue?vue&type=template&id=6c89110c&scoped=true"
import script from "./DadosdoSubordinado.vue?vue&type=script&lang=js"
export * from "./DadosdoSubordinado.vue?vue&type=script&lang=js"
import style1 from "./DadosdoSubordinado.vue?vue&type=style&index=1&id=6c89110c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c89110c",
  null
  
)

export default component.exports